<style>



</style>

<template>

<div v-if="module">
    <!-- <v-runtime-template :template="'<div>' + chart.chartData.template + '</div>'" :key="componentKey" />
    
    <component is="script">
        {{ javascript }}
    </component> -->
    <!-- <dynamic :comps="comps" :emptyView="emptyView" @click.native="onClick" @customEvent="onCustomEvent"/>
    <button @click="changeView">changeView</button> -->
    <v-runtime-template :template="'<div>' + chart.chartData.template + '</div>'" :key="componentKey" />
    <!-- <component  v-bind:is="dynamicComponent" v-if="dynamicComponent" :key="componentKey"></component> -->
    <component :is="'style'">
        {{ stylesheet }}
    </component>
</div>

</template>

<script>

import VRuntimeTemplate from "v-runtime-template";
import {
  createNamespacedHelpers
}
from 'vuex';

const chartNamespace = createNamespacedHelpers('charts');
const userNamespace = createNamespacedHelpers("users");

import {VImg, VListGroup, VNavigationDrawer, VTabs, VTab, VTabItem, VTabsItems, VSnackbar,VListTileSubTitle, VListTileAvatar, VListTileContent, VListTileAction,VSubheader, VBtn, VBtnToggle, VIcon, VChip, VAvatar, VRating, VProgressCircular, VProgressLinear, VDialog, VCard, VCardTitle, VCardText, VDivider, VCardActions, VSpacer, VContainer, VLayout, VFlex, VToolbar, VToolbarSideIcon, VToolbarTitle, VExpansionPanel, 
VExpansionPanelContent, VMenu, VList, VListTile, VListTileTitle, VTextField, VSlider, VSelect, VSheet, VCalendar,
VApp, VContent, VFooter, VTimeline, VTimelineItem, VDataTable } from 'vuetify/lib';
import ApiService from "@/services/api.service";
import EditorElement from "@/components/charts/form/builder/editor-element.vue";
const TaybullEchart = () => import('@/components/charts/echart/chart.vue');
const TopUp = () => import('@/components/charts/payment/topup.vue');
const BuyElectricity = () => import('@/components/charts/payment/buy-electricity.vue');
const RequestMoney = () => import('@/components/charts/payment/request-money.vue');
import JwtService from "@/services/jwt.service";


let user = JwtService.getUser();

import FormView from "./form-view.vue";
import guid from '@/lib/guid';
import PasswordGenerator from '@/lib/password-generator';
import { createDataSource } from '@/models/data-source';
import dayjs from 'dayjs';


const dataSource = createDataSource({});
import template from "string-template";
dataSource.updateType = "api";

const emptyView = {
        template: '<div>There is nothing now!</div>',
      }

function load(id, tag, content) {
  if(!id || !tag || !content) {
    // alert("empty");
    return false;
  }
  let element = document.getElementById(id);
  if(element) {
    element.innerHTML = content;
  } else {
    element = document.createElement(tag);
    element.setAttribute("id", id);
    document.head.appendChild(element);
  }
}

function loadScript(id, content) {
  load(id, "script", content);
}

function loadStyle(id, content) {
  load(id, "style", content);
}

function looseJsonParse(obj){
    return Function('"use strict";return (' + obj + ')')();
}

export default {
    name: "dynamic-html-chart",
    data: function() {
        return {
          dynamicComponent: null,
          comps: null,
          emptyView,
          results: [],
          stylesheet: "",
          javascript: "",
          response: {},
          interval: null,
          componentKey: 0,
          module: {},
          dialogControl: {},
          routeParams: {documentId: 1, contractId: 1},
          intervals: {}
        };
    },
    props: ['chart'],
    components: {
      EditorElement,
      FormView,
        'v-runtime-template': VRuntimeTemplate,
        'v-btn': VBtn,
        'v-icon': VIcon,
        'v-chip': VChip,
        'v-avatar': VAvatar,
        'v-rating': VRating,
        'v-progress-circular': VProgressCircular,
        'v-progress-linear': VProgressLinear,
        'v-dialog': VDialog,
        'v-card': VCard,
        'taybull-echart': TaybullEchart,
        'v-text-field': VTextField,
        'v-slider': VSlider,
        'top-up': TopUp,
        'buy-electricity': BuyElectricity,
        'request-money': RequestMoney,
        VImg,
        VTabs, 
        VTab, 
        VTabItem,
        VTabsItems,
        VSnackbar,
        VCardTitle, 
        VCardText, 
        VDivider, 
        VCardActions, 
        VSpacer,
        VContainer, 
        VLayout, 
        VFlex,
        VToolbar, 
        VToolbarSideIcon, 
        VToolbarTitle,
        VExpansionPanel, 
        VExpansionPanelContent,
        VExpansionPanelContent, 
        VMenu, 
        VList, 
        VListTile, 
        VListTileTitle,
        VBtnToggle,
        VListTileSubTitle,
        VListTileAvatar, 
        VListTileContent, 
        VListTileAction,
        VSubheader,
        VListGroup,
        VNavigationDrawer,
        VSelect,
        VSheet,
        VCalendar,
        VApp, 
        VContent, 
        VFooter,
        VTimeline, 
        VTimelineItem,
        VDataTable,
    },
    methods: {
      ...userNamespace.mapActions(['aSubscribe']),
      ...chartNamespace.mapMutations(['mSetSubChart', 'mReloadChartLayout', 'mReInitializeGridsById']),
      reInitialiseGrids(chart) {
        this.mReInitializeGridsById(chart.getParentId());
      },
      toTitle(camelCase) {
        // no side-effects
        return camelCase
          // inject space before the upper case letters
          .replace(/([A-Z])/g, function(match) {
            return " " + match;
          })
          // replace first char with upper case
          .replace(/^./, function(match) {
            return match.toUpperCase();
          });
      },
      createForm(params) {
        // ...formElementSchema, 
        return { ...params };
        // alert(JSON.stringify(params));
      }

    },
    mounted() {
        let that = this;
        let last = that.chart.chartData.template;
        const chart = this.chart;

        // let stylesheet = this.$refs.stylesheet;
        // loadScript("javascript-"+chart.id, chart.parameters.javascript.value);
        // loadStyle("stylesheet-"+chart.id, chart.parameters.stylesheet.value);

        // console.log("stylesheet", stylesheet);

        that.module = {};
        chart.reload = function() {
            if (that.chart.chartData.lastUpdated != that.lastUpdated) {
                that.componentKey++;
                last = that.chart.chartData.template
                that.lastUpdated = that.chart.chartData.lastUpdated;

                that.stylesheet = chart.parameters.stylesheet.value;
                that.javascript = chart.parameters.javascript.value;
                let dynamicComponent = {};
                if(that.javascript) {
                  try {
                  that.javascript = that.javascript.replace("module.export =", "").trim();
                  // console.log("that.javascript", that.javascript);
                  let parsed = looseJsonParse(that.javascript);
                  dynamicComponent = parsed;
                  
                  that.module = new parsed;
                  that.module.global = { user };
                  that.module.api = ApiService;
                  that.module.lib = {};
                  that.module.lib.moment = dayjs;
                  that.module.lib.pusher = that.$pusher;
                  that.module.$refs = that.$refs;
                  

                  that.module.parent = that;
                  that.module.routeParams = that.routeParams;
                  that.module.guid = guid;
                  that.module.codeGenerator = new PasswordGenerator();
                  that.module.item = that.chart.getReference("dialogItem");
                  that.module.reloadDashboard = () => {
                    that.reInitialiseGrids(that.chart);
                  };
                  // console.log("that.module.item", that.module.item);

                  that.module.setInterval = function(name, fnc, timer) {
                    if(typeof that.intervals[name] != "undefined") {
                      clearInterval(that.intervals[name]);
                    }
                    that.intervals[name] = setInterval(fnc, timer);
                  }

                  that.module.subscribe = function(payload) {
                    that.aSubscribe(payload);
                  }

                  that.module.db = {
                    query: function(statement, params) {
                      const sql =  template(statement, params);
                      let query = {};
                      query.id = 78985888588888;
                      query.sql = sql;
                      return dataSource.request(query);
                    },
                    save: function(params) {
                      return ApiService.post("/table/save", params);
                    },
                    update: function(params) {
                      return ApiService.post("/table/update", params);
                    },
                    findOne: function(params) {
                      // console.log("params", params);
                      return ApiService.post("/table/find/one", params);
                    },
                    findAll: function(params) {
                      return ApiService.post("/table/find/all", params);
                    },
                    delete: function(params) {
                      
                    }
                  }

                  
                  if(typeof that.module.mounted != "undefined") {
                    that.module.mounted();
                  }



                  } catch(error) {
                    console.log("error", error);
                    alert(error);
                  }
                }
                dynamicComponent.template = '<div>' + last + '</div>';
                that.dynamicComponent = dynamicComponent;
            }
        }
        //, 1000);

        this.chart.updateUI =  function(key, value) {
          that[key] = value;
        }

        chart.reload();
    },
    beforeDestroy() {
      try {
        clearInterval(this.interval);
        this.interval  = null;
      } catch(err) {
        //
      }

      // this.editor.destroy();
    }
}

</script>
